/* eslint-disable no-use-before-define */
import { useEffect, useState } from 'react';

import { deleteRecord, getRecordsList, updateRecords } from '../../../api';
import { formatDate } from '../../../utils/date';
import updateRecordComment from '../../../api/records/updateRecordComment';
import deleteRecordComment from '../../../api/records/deleteRecordComment';


export const useRecordsList = (requestId, rerender) => {
  const [data, updateData] = useState([]);
  const [loading, updateLoading] = useState(false);

  const deleteRecordRequest = recordId => async () => {
    updateLoading(true);
    const resp = await deleteRecord(recordId);

    if (resp !== undefined) {
      updateData(data.filter(item => item.id !== recordId));
    }

    updateLoading(false);
  };

  const deleteRecordRequestComment = requestRecordId => async () => {
    updateLoading(true);
    const resp = await deleteRecordComment(requestRecordId);
    if (resp) {
      const updatedData = data.map((item) => {
        if (item.id === requestRecordId) {
          item.comments = resp.comments;
          item.commentCreator = resp.commentCreator;
          item.lastCommentUpdate = resp.lastCommentUpdate;
        }
        return item;
      });

      updateData(updatedData);
      updateLoading(false);
    }
  };
  const updateStatusRecords = async (ids, groupStatus) => {
    updateLoading(true);
    const entities = ids.map(id => ({ id }));
    const response = await updateRecords({ entities, approvalAction: groupStatus });

    if (response) {
      const updatedData = data.map((item) => {
        const itemIndex = response.findIndex(updated => updated.id === item.id);
        if (itemIndex > -1) {
          item.groupStatus = response[itemIndex].groupStatus;
        }

        return item;
      });

      updateData(updatedData);
      updateLoading(false);
    }
  };
  const updateItemComment = async (record, comment) => {
    updateLoading(true);
    const recordToUpdate = { id: record.id, comment, lastCommentUpdate: formatDate(new Date(), 'DD/MM/YYYY') };
    const response = await updateRecordComment(recordToUpdate);

    if (response) {
      const updatedData = data.map((item) => {
        if (item.id === response.id) {
          item.comments = response.comments;
          item.commentCreator = response.commentCreator;
          item.lastCommentUpdate = response.lastCommentUpdate;
        }

        return item;
      });

      updateData(updatedData);
      updateLoading(false);
    }
  };

  useEffect(() => {
    updateData([]);

    const fetchData = async () => {
      updateLoading(true);
      const response = await getRecordsList({ preSettlementRequestId: requestId });
      updateLoading(false);

      if (response) {
        updateData(response);
      }
    };

    fetchData();
  }, [requestId, rerender]);

  return [data, loading, updateStatusRecords, deleteRecordRequest, updateItemComment, deleteRecordRequestComment];
};
